import { useTranslation } from "react-i18next";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import BlockIcon from "@mui/icons-material/Block";
import Tooltip from "@mui/material/Tooltip";

export function CancelButton(props: IconButtonProps) {
  const { t } = useTranslation();

  return (
    <Tooltip title={<div>{t("common.cancel")}</div>}>
      <IconButton color="primary" {...props} size="large">
        <BlockIcon color="error" />
      </IconButton>
    </Tooltip>
  );
}
